(function() {
  var FormKo, ValidationEngine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  FormKo = App.loadClass("grower::viewmodels/nitrogen/Form");

  ValidationEngine = App.loadClass("core::ValidationEngine");

  exports.Layer_Nitrogen_Dialog = (function(superClass) {
    extend(Layer_Nitrogen_Dialog, superClass);

    function Layer_Nitrogen_Dialog() {
      return Layer_Nitrogen_Dialog.__super__.constructor.apply(this, arguments);
    }

    Layer_Nitrogen_Dialog.prototype.init = function() {
      this.layoutUrl = 'backend/grower/layers/nitrogen/dialog';
      this.classes = 'large_dialog';
      this.createDialog();
      return this.validator = new ValidationEngine();
    };

    Layer_Nitrogen_Dialog.prototype.getPostData = function() {
      var data;
      data = "id=" + this.loadLayoutPostOptions.id + "&json=" + ko.toJSON(this.formKO);
      return data;
    };

    Layer_Nitrogen_Dialog.prototype.afterLoadLayout = function(selector, response) {
      var ref, ref1, writer;
      this.openDialog();
      writer = this.dialog.find('.message_writer');
      writer.message_writer((ref = response.status) != null ? ref.type : void 0, (ref1 = response.status) != null ? ref1.msg : void 0);
      this.formKO = new FormKo(this, response.data, this.validator);
      return ko.applyBindings(this.formKO, this.dialog[0]);
    };

    return Layer_Nitrogen_Dialog;

  })(DialogHandler);

}).call(this);
